export default __webpack_public_path__ + "static/media/ic_mongolia.1ce99666.svg";